import gettext from '@sdk/lang/gettext';
import { AttestationOption } from '@sdk/automatedBreaks/types/Attestation';

import stringifyBreakViolations from '@web/timeClock/utils/stringifyBreakViolations';

import timesheetsReportColumnUrl from './timesheetsReportColumn.html';
import clockInMapUrl from './clockInMap.html';
import clockOutMapUrl from './clockOutMap.html';

export default function timesheetsReportColumn() {
  return {
    templateUrl: timesheetsReportColumnUrl,
    scope: {
      data: '<',
      schema: '<',
      selectedRows: '=',
      type: '<timesheetsReportColumn',
      isTotals: '<?',
      showDurationsAsDecimals: '<?',
      showCheckbox: '<',
      onCellCollapseChange: '&',
    },
    controllerAs: 'ctrl',
    controller(Authentication, PersonaCollection, Utils, UserUtils, GoogleMapsService, $scope) {
      'ngInject';

      this.Authentication = Authentication;
      this.PersonaCollection = PersonaCollection;
      this.Utils = Utils;
      this.UserUtils = UserUtils;
      this.AttestationOption = AttestationOption;
      this.stringifyBreakViolations = stringifyBreakViolations;
      this.premiumPayAppliedText = gettext('Premium pay applied');
      this.syncingWithToastErrorTooltip = gettext(
        'Position or Employee does\nnot exist in Toast, time\nentry will not be synced'
      );

      this.getSyncErrorMessage = (errors) => {
        errors = errors.toString();
        if (errors === 'missing_user') {
          return gettext("Employee doesn't exist in Toast, time entry will not be synced");
        } else if (errors === 'missing_location') {
          return gettext("Location doesn't exist in Toast, time entry will not be synced");
        } else if (errors === 'unassigned_location') {
          return gettext(
            "Employee isn't assigned to this location in Toast, time entry will not be synced"
          );
        } else if (errors === 'missing_position') {
          return gettext("Position doesn't exist in Toast, time entry will not be synced");
        } else if (errors === 'unassigned_position') {
          return gettext(
            "Employee isn't assigned to this position in this location in Toast, time entry will not be synced"
          );
        }
      };

      this.canActorSeePremiumPay = $scope.data?.user
        ? this.UserUtils.canManageUser(this.PersonaCollection.personasDict[$scope.data.user.id])
        : false;

      this.onCellCollapseChange = () => {
        $scope.onCellCollapseChange?.({ event: $scope.data });
      };

      this.eval = (exp) =>
        this.Utils.evaluateExpression(exp, {
          options: {
            showDurationsAsDecimals: $scope.showDurationsAsDecimals,
            isPastDtendWithNoClockIn: !$scope.isTotals && $scope.data.isPastDtendWithNoClockIn,
          },
        });

      this.clockInMapUrl = clockInMapUrl;
      this.clockOutMapUrl = clockOutMapUrl;
      this.hasToastIntegration = this.Authentication.user.org.hasToastIntegration;

      this.loadMaps = () => {
        GoogleMapsService.load();
      };
    },
  };
}
